module.exports = __webpack_public_path__ + "img/南沙参.e6a1b58b.jpg";